import { render } from "./EDAPremiumPreSaleSection.vue?vue&type=template&id=4a46f143"
import script from "./EDAPremiumPreSaleSection.vue?vue&type=script&lang=js"
export * from "./EDAPremiumPreSaleSection.vue?vue&type=script&lang=js"

import "./EDAPremiumPreSaleSection.vue?vue&type=style&index=0&id=4a46f143&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__